/**
 * @namespace Refresh
 * @aka S3.Refresh
 */
S3.Refresh = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = "refresh";
  var DATA_KEY = "swr3.refresh";
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = ".data-api";
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: "pjax:end" + EVENT_KEY + DATA_API_KEY
  };
  var Selector = {
    DATA_SPY: 'img[data-spy="refresh"]'
  };

  var Default = {
    interval: 30000
  };

  var DefaultType = {
    interval: "number"
  };

  /**
   *
   */
  var forEachPictureSource = function forEachPictureSource(element, fn) {
    var parent = element.parentNode;

    if (!parent || parent.tagName !== "PICTURE") {
      return;
    }

    var sourceTags = getSourceTags(parent);
    sourceTags.forEach(fn);
  };

  var getSourceTags = function getSourceTags(parentTag) {
    var sourceTags = [];

    for (var i = 0, childTag; childTag = parentTag.children[i]; i += 1) {
      if (childTag.tagName === "SOURCE") {
        sourceTags.push(childTag);
      }
    }

    return sourceTags;
  };

  /**
   *
   */
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var integerRegex = /^\d+$/;

  function deepUnique(array) {
    return array.sort().filter(function (element, index) {
      return JSON.stringify(element) !== JSON.stringify(array[index - 1]);
    });
  }

  var parse = function (string) {
    return deepUnique(string.split(',').map(function (part) {
      var result = {};
      part.trim().split(/\s+/).forEach(function (element, index) {
        if (index === 0) {
          result.url = element;
          return;
        }

        var value = element.slice(0, element.length - 1);
        var postfix = element[element.length - 1];
        var integerValue = parseInt(value, 10);
        var floatValue = parseFloat(value);

        if (postfix === 'w' && integerRegex.test(value)) {
          result.width = integerValue;
        } else if (postfix === 'h' && integerRegex.test(value)) {
          result.height = integerValue;
        } else if (postfix === 'x' && !Number.isNaN(floatValue)) {
          result.density = floatValue;
        } else {
          throw new Error("Invalid srcset descriptor: ".concat(element));
        }
      });
      return result;
    }));
  };
  var stringify = function (array) {
    return _toConsumableArray(new Set(array.map(function (element) {
      if (!element.url) {
        throw new Error('URL is required');
      }

      var result = [element.url];

      if (element.width) {
        result.push("".concat(element.width, "w"));
      }

      if (element.height) {
        result.push("".concat(element.height, "h"));
      }

      if (element.density) {
        result.push("".concat(element.density, "x"));
      }

      return result.join(' ');
    }))).join(', ');
  }

  /**
   *
   */
  var Refresh = (function () {
    function Refresh(element, config) {
      var self = this;

      if (S3.PSO || S3.Browser.isBot) {
        return;
      }

      // private
      if (null !== self._interval) {
        window.clearInterval(self._interval);
      }
      self._interval = null;

      // protected
      self.element = element;

      var dataSrc = self.element.getAttribute('data-src');
      if (null === dataSrc || "" === dataSrc) {
        return;
      }

      self.config = self._getConfig(config);

      self._setObserver();
      if (self._observer) {
        self._observer.observe(self.element);
      } else {
        // Fallback
        self._interval = window.setInterval(self.update.bind(self), self.config.interval);
        self.update();
      }

      $(document).one('pjax:beforeReplace', function () {
        self.dispose();
      })
    }

    Refresh.prototype.update = function update() {
      var self = this

      /*
       *
       */
      var now = Date.now() / 1000 | 0;
      var ts = now / 1e1 + '';
      var values = ts.split('.');
      var a = parseInt(values[0]);
      var b = parseInt(values[1]);
      var cachingVersion = a + '' + (isNaN(b) || b < 5 ? 0 : 5);

      /*
       *
       */
      forEachPictureSource(self.element, function (sourceTag) {
        var elSrcset = sourceTag.getAttribute('data-srcset') || sourceTag.getAttribute('srcset');
        if (null !== elSrcset) {
          var parsed = parse(elSrcset);
          parsed.forEach(function (item) {
            var url = new URL(item.url);
            var search_params = url.searchParams;
            search_params.set('_', cachingVersion);
            // change the search property of the main url
            url.search = search_params.toString();
            // the new url string
            item.url = url.toString();
          })
          sourceTag.setAttribute('srcset', stringify(parsed))
        }
      })

      /*
       *
       */
      var elSrcset = self.element.getAttribute('data-srcset') || self.element.getAttribute('srcset');
      if (null !== elSrcset) {
        var parsed = parse(elSrcset);
        parsed.forEach(function (item) {
          var url = new URL(item.url);
          var search_params = url.searchParams;
          search_params.set('_', cachingVersion);
          // change the search property of the main url
          url.search = search_params.toString();
          // the new url string
          item.url = url.toString();
        })
        self.element.setAttribute('srcset', stringify(parsed))
      }
      var src = self.element.getAttribute('data-src');
      src += '?' + cachingVersion;
      self.element.setAttribute('src', src);

      if ('function' === typeof window.picturefill) {
        window.picturefill({
          reevaluate: true,
          elements: self.element
        });
      }
    }

    Refresh.prototype.interval = function interval(i) {
      var self = this;

      if ('number' !== typeof i) {
        return;
      }

      self.config.interval = i;
    };

    Refresh.prototype._setObserver = function _setObserver() {
      var self = this;

      if (!("IntersectionObserver" in window)) {
        return;
      }

      var onIntersection = function onIntersection(entries) {
        entries.forEach(function (entry) {
          // entry.isIntersecting is null on some versions of MS Edge
          // entry.intersectionRatio can be 0 on some intersecting elements
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            if (null === self._interval) {
              self._interval = window.setInterval(self.update.bind(self), self.config.interval);
              self.update();
            }
          } else {
            if (null !== self._interval) {
              window.clearInterval(self._interval);
              self._interval = null;
            }
          }
        });
      };

      self._observer = new IntersectionObserver(onIntersection, {
        root: null,
        rootMargin: '100px',
        threshold: 0
      });
    };

    // public
    Refresh.prototype.dispose = function dispose() {
      if (this._observer) {
        this._observer.unobserve(this.element);
        this._observer = null;
      }

      if (null !== this._interval) {
        window.clearInterval(this._interval);
      }
      this._interval = null;

      $(this.element).off(EVENT_KEY);
      $.removeData(this.element, DATA_KEY);

      this.element = null;
      this.config = null;
    };

    // private
    Refresh.prototype._getConfig = function _getConfig(config) {
      config = extend({}, Default, config);

      S3.Util.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    /**
     * @static
     */
    Refresh._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : S3.Util._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Refresh(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return Refresh;
  })();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Refresh._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Refresh._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Refresh._jQueryInterface;
  $.fn[NAME].Constructor = Refresh;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Refresh._jQueryInterface;
  };

  return Refresh;
})(window.jQuery);
